export default {"src":"/_next/static/media/icon-advise-new.eec4788f.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};